<template>
  <h4 style="font-size: 12px; color: #10425a">
    <span>
      <input
        class="search"
        :id="'search' + table"
        v-on:keyup="search(table)"
        style="width: 50%"
        type="text"
        :placeholder="placeholder"
      />
    </span>
  </h4>
</template>

<script>
export default {
  name: "table_search",
  props: {
    table: String,
    placeholder: String
  },
  methods: {
    searchTable: function () {
      this.searchWithPassengerMetadata(this.table);
    },
    search: function (table) {

          var input, filter, table, tr, td, i, txtValue;

          input = document.getElementById("search" + this.table);
          filter = input.value.toUpperCase();
          table = document.getElementById(table);
          tr = table.getElementsByTagName("tr");

          this.$emit("changed", filter);
          
          var headerName = this.table + "-header-row";
          // Check if the filter starts with 'd' or 'D'
          var firstColumnOnly = false;
          if (filter.startsWith("D")) {
              firstColumnOnly = true;
              filter = filter.slice(1); // Remove the first character 'D' from filter
          }
          
          // Loop through all table rows, and hide those who don't match the search query
          for (i = 0; i < tr.length; i++) {
              let td = tr[i];
              if (td && td.id !== headerName) {
                  if (firstColumnOnly) {
                      td = tr[i].getElementsByTagName("td")[0]; // Get only the first column if its driver search
                  }

                  if (td) {
                      txtValue = td.textContent || td.innerText;
                      if (txtValue.toUpperCase().includes(filter)) {
                          tr[i].style.display = "";
                      } else {
                          tr[i].style.display = "none";
                      }
                  }
              }
          }
      },
    searchLegacy: function (table) {
      var input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("search" + this.table);
      filter = input.value.toUpperCase();
      table = document.getElementById(table);
      tr = table.getElementsByTagName("tr");

      var headerName = this.table + "-header-row";
      
      // Loop through all table rows, and hide those who don't match the search query
      for (i = 0; i < tr.length; i++) {
        // td = tr[i].getElementsByTagName("td")[0];
        let td = tr[i];
        if (td && td.id != headerName) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            td.style.display = "";
          } else {
            td.style.display = "none";
          }
        }
      }
    },
    searchWithPassengerMetadata: function (table) {
          
          var input, filter, table, tr, td, i, txtValue;
          input = document.getElementById("search" + this.table);
          filter = input.value.toUpperCase();
          table = document.getElementById(table);
          tr = table.getElementsByTagName("tr");
          
          var headerName = this.table + "-header-row";
          
          // Check if filter starts with 'd' or 'D'
          var firstColumnOnly = false;
          var searchMetaData = false;
          if (filter.startsWith("D")) {
              firstColumnOnly = true;
              filter = filter.slice(1);
          } else if (filter.startsWith("P")) {
              searchMetaData = true;
              filter = filter.slice(1);
          }
          
          // Loop through all table rows
          for (i = 0; i < tr.length; i++) {
              let td = tr[i];
              if (td && td.id !== headerName) {
                  if (firstColumnOnly) {
                      td = tr[i].getElementsByTagName("td")[0];
                  } else if (searchMetaData) {
                      td = tr[i].getElementsByTagName("td")[6];
                  }
                  
                  if (td) {
                      txtValue = td.textContent || td.innerText;
                      
                      if (searchMetaData) {
                          const hiddenSpan = td.querySelector('[data-type="metadata"]');
                          if (hiddenSpan) {
                              const metaData = hiddenSpan.textContent || hiddenSpan.innerText;
                              txtValue += metaData;
                          }
                      }
                      
                      if (txtValue.toUpperCase().indexOf(filter) > -1) {
                          tr[i].style.display = "";
                      } else {
                          tr[i].style.display = "none";
                      }
                  }
              }
          }
      }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#gridcontainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  bottom: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 24px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
}

td {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}

.search {
  outline: none;
}
</style>
